import React from 'react';
import type { FeedbackType } from '../../types';

interface FeedbackOverlayProps {
  feedback: FeedbackType;
}

export const FeedbackOverlay: React.FC<FeedbackOverlayProps> = ({ feedback }) => {
  if (feedback === 'NONE') return null;

  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm animate-in fade-in duration-200">
      {feedback === 'LEVEL_UP' ? (
        <>
          <div className="text-9xl mb-4 animate-bounce">🎉</div>
          <div className="text-4xl font-bold text-orange-500 mb-2">クリア！</div>
          <div className="text-xl font-bold text-gray-600">つぎのステージへ！</div>
        </>
      ) : (
        <>
          <div className="text-9xl mb-4">{feedback === 'CORRECT' ? '⭕' : '❌'}</div>
          <div
            className={`text-4xl font-bold ${
              feedback === 'CORRECT' ? 'text-green-600' : 'text-red-500'
            }`}
          >
            {feedback === 'CORRECT' ? 'せいかい！' : 'ヒントを見て！'}
          </div>
        </>
      )}
    </div>
  );
};
